import { Business } from 'core/empresa/models/Business';
import { Pageable } from 'shared/table/models/Pageable';
import { AccountTotals } from './AccountTotals';

export class AccountsTotalsData {
  empresa: Business;
  cuentas: Pageable<AccountTotals>;
  totales: AccountTotals;

  constructor(data: {
    denominacionEmpresa: string;
    totalesPorCuenta: Pageable<AccountTotals>;
    totalesEmpresa: AccountTotals;
  }) {
    if (data) {
      this.empresa = {
        denominacion: data.denominacionEmpresa,
      };
      this.cuentas = data.totalesPorCuenta;
      this.totales = data.totalesEmpresa;
    }
  }
}
